export const SearchBar = () => {

    return <div className="main-header-center ms-4 d-sm-none d-md-none d-lg-block form-group">
        <input className="form-control" placeholder="Search..." type="search" />
        <button className="btn"><i className="fas fa-search"></i></button>
    </div>;
}